import React from 'react';
import { useLocalization, useLocale, useLocalizationDispatch } from '../../context/Localization/localization';
import { GenericClickable } from '../GenericClickable/GenericClickable';
import { CTAButton } from '../ButtonBase/index';
import css from './LocalizationButtons.module.scss';
import { useKioskState } from '../../context/Kiosk/kiosk';
import { Locales, LocalesFull, LocalizationDispatchTypes } from '../../context/Localization/localization.types';

export const LocalizationButtons = (props: { displayAsLinks?: true; }) => {
    const Localization = useLocalization();
    const currentLocale = useLocale();
    const localeDispatch = useLocalizationDispatch();
    const {
        dealer: { primaryLanguage, alternateLanguage },
    } = useKioskState();
    const otherLanguages = [primaryLanguage, alternateLanguage].filter((locale) => locale !== currentLocale && locale !== Locales.none);
    const onClick = React.useCallback((locale: Locales) => localeDispatch({ type: LocalizationDispatchTypes.SetLocale,
        payload: locale }), [localeDispatch]);

    if (!otherLanguages.length) {
        return null;
    }
    else {
        return (
            <div data-testid={'localization-buttons'} className={css.localizationButtons}>
                {otherLanguages.map((locale: Locales) => {
                    const display =
                        Localization.getString(LocalesFull[locale], locale) || Localization.getString(LocalesFull[locale], Locales.en);

                    return props.displayAsLinks ? (
                        <GenericClickable
                            key={locale}
                            className={css.languageLink}
                            onClick={() => {
                                onClick(locale);
                                setTimeout(() => window.dispatchEvent(new Event('resize')));
                            }}
                        >
                            {display}
                        </GenericClickable>
                    ) : (
                        <CTAButton
                            hideIcon
                            key={locale}
                            onClick={() => {
                                onClick(locale);
                                setTimeout(() => window.dispatchEvent(new Event('resize')));
                            }}
                            label={display}
                            styleType={'secondary'}
                            id={display}
                            ariaLabel={display}
                        />
                    );
                })}
            </div>
        );
    }
};
